import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BellRinging04 = function BellRinging04(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M17.4906 9.4453c-.3569-1.3322-1.3098-2.4461-2.6491-3.0968-1.3393-.6508-2.9552-.785-4.4923-.3731-1.537.4118-2.8694 1.336-3.7039 2.5692-.8344 1.2332-1.1027 2.6744-.7458 4.0065.5906 2.2041.476 3.9624.103 5.2986-.4251 1.5228-.6376 2.2843-.5802 2.4372.0657.1749.1132.2229.2874.2904.1523.059.792-.1124 2.0716-.4553l11.8651-3.1792c1.2795-.3429 1.9193-.5143 2.0217-.6415.1171-.1456.1343-.2109.1037-.3953-.0267-.1611-.5915-.7142-1.721-1.8205-.9911-.9707-1.9696-2.4362-2.5602-4.6402Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.6459 18.0148c.4288 1.6004-.5209 3.2454-2.1213 3.6742-1.6004.4288-3.2454-.5209-3.6742-2.1213m-7.7936-7.9544c-.3895-1.3982.0156-2.9098 1.052-3.926m9.0375-1.9464a2.492 2.492 0 0 0 .2296-1.8615c-.3574-1.3336-1.7282-2.125-3.0619-1.7677-1.3337.3573-2.1251 1.7282-1.7678 3.0618a2.4918 2.4918 0 0 0 1.1295 1.4973M20.319 6.72c-.3618-1.4056-1.4684-2.5122-2.874-2.874m.0456 5.5993c-.3569-1.3322-1.3098-2.4461-2.6491-3.0968-1.3393-.6508-2.9552-.785-4.4923-.3731-1.537.4118-2.8694 1.336-3.7039 2.5692-.8344 1.2332-1.1027 2.6744-.7458 4.0065.5906 2.2041.476 3.9624.103 5.2986-.4251 1.5228-.6376 2.2843-.5802 2.4372.0657.1749.1132.2229.2874.2904.1523.059.792-.1124 2.0716-.4553l11.8651-3.1792c1.2795-.3429 1.9193-.5143 2.0217-.6415.1171-.1456.1343-.2109.1037-.3953-.0267-.1611-.5915-.7142-1.721-1.8205-.9911-.9707-1.9696-2.4362-2.5602-4.6402Z"
    })]
  }));
};
export default BellRinging04;